import {OrdersAndItemsTab} from '../../../../types/types'
import {primitiveAtomWithLS} from '@app/utils/reatom'

export const toWarehouseCurrentTab = primitiveAtomWithLS<OrdersAndItemsTab>(
  'byOrders',
  'toWarehouse.currentTab',
)
